/* -------------------------------------------------------------------------------------------------
Restricted - Copyright (C) Siemens Healthcare GmbH/Siemens Medical Solutions USA, Inc., 2020. All rights reserved
------------------------------------------------------------------------------------------------- */
import { css, html, LitElement } from 'lit-element';
import { sharedStyles } from '../../styles';

/**
 * !NoApi
 */
export class SHBreadcrumbs extends LitElement {
  static get properties() {
    return {};
  }

  static get styles() {
    return [
      sharedStyles,
      css`
        :host {
          float: left;
          display: block;
          overflow: hidden;
        }
      `,
    ];
  }

  render() {
    return html` <slot @slotchange="${this._handleSlotChange}"></slot> `;
  }
  _handleSlotChange() {
    const breadcrumbItems = this.querySelectorAll('sh-breadcrumb-item');
    for (let i = 0; i < breadcrumbItems.length; i++) {
      breadcrumbItems[i].active = true;
      if (breadcrumbItems[i - 1] && breadcrumbItems[i] !== breadcrumbItems.length)
        breadcrumbItems[i - 1].active = false;
    }
  }
}
customElements.define('sh-breadcrumbs', SHBreadcrumbs);
